import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

// Components
import { PredicateRowActions } from './PredicateRowActions';
import { IconNoToggle } from '../../../../../../../../components/SvgIcons/IconNoToggle';
import { Tooltip } from '../../../../../../../../components/Tooltip';

// Hooks
import { useCriteriaStorePredicate } from '../../../../../../state/criteria/hooks/useCriteriaStorePredicate';
import { useCriteriaStoreLastMovedUuid } from '../../../../../../state/criteria/hooks/useCriteriaStoreLastMovedUuid';

// Styles
import { PredicateRowIndent } from '../../../../../../../../common/styles/mixins';

export const FlexContainer = styled(({ previewOnly, cursor, isGroup, isdragging, indent, moved, ...rest }) => (
    <li {...rest} />
))`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: ${({ cursor }) => cursor || 'default'};
    /* margin-bottom: ${({ isGroup }) => (isGroup ? '0.5rem' : '0')}; */
    /* gap: 4px; */
    position: relative;
    padding: 4px 0;
    ${PredicateRowIndent};
    /* * {
        z-index: 1;
    } */
    ${({ previewOnly }) => {
        if (previewOnly) {
            return css`
                pointer-events: none;
            `;
        } else {
            return css`
                :before {
                    content: '';
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: -300px;
                    left: 0px;
                    right: -14px;
                    background: transparent;
                    transition: background 0.15s ease;
                    /* border-bottom: 1px solid #80808017;
                    border-top: 1px solid #80808017; */
                }
                &:hover {
                    :before {
                        background: #e7f6ff;
                    }
                }
            `;
        }
    }}
`;

export const PredicateRow = ({
    predicateUuid,
    previewOnly,
    isGroup,
    dragHandleProps,
    canReorder,
    children,
    nestedLevel
}) => {
    const predicate = useCriteriaStorePredicate(predicateUuid);
    const lastMovedUuid = useCriteriaStoreLastMovedUuid();
    const isLastMoved = React.useMemo(() => {
        return predicateUuid === lastMovedUuid;
    }, [predicateUuid, lastMovedUuid]);

    return (
        <FlexContainer
            style={{ gap: '4px' }}
            previewOnly={previewOnly}
            cursor={isGroup ? 'pointer' : 'default'}
            isGroup={isGroup}
            indent={nestedLevel}
            className="predicate-row"
            moved={isLastMoved}
        >
            {predicate.activeOverridable ? null : (
                <Tooltip
                    transitionFlip={false}
                    followCursor={false}
                    trigger="mouseenter"
                    delay={500}
                    arrow={true}
                    title={'Predicate toggle is not visible.'}
                    position="top"
                    style={{
                        zIndex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '4px'
                    }}
                >
                    <IconNoToggle size={24} color={'#52a1f3'} />
                </Tooltip>
            )}
            {children}
            <PredicateRowActions
                predicateUuid={predicateUuid}
                dragHandleProps={dragHandleProps}
                canReorder={canReorder}
                canAdd={isGroup}
            />
        </FlexContainer>
    );
};

export default PredicateRow;

PredicateRow.propTypes = {
    predicateUuid: PropTypes.string,
    isGroup: PropTypes.bool,
    canReorder: PropTypes.bool,
    nestedLevel: PropTypes.number,
    previewOnly: PropTypes.bool,
    children: PropTypes.node,
    dragHandleProps: PropTypes.object
};
